import { withZod } from '@remix-validated-form/with-zod';
import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { fileServerSchema } from '../../schemas';
import { booleanField } from '../../zod';
import { decorationSchema, decorationSchemaServer } from '../decoration';
import { teamNameSchema, teamNameServerSchema } from './teamNames';
import { DesignParamAction } from './utils';

const sizeSchema = z.object({
	size: z.string(),
	quantity: zfd.numeric(),
});

export type Size = z.infer<typeof sizeSchema>;

export const merchSchema = z.object({
	action: z.nativeEnum(DesignParamAction).optional(),
	dirty: booleanField(),
	artworkChanged: booleanField(),
	sameday: z.coerce.string().transform(val => val === 'true'),
	name: z.string().optional(),
	scene: z.string().optional(),
	decorations: z.array(decorationSchema),
	colour: z.string(),
	sizing: z.array(sizeSchema),
	teamNames: teamNameSchema,
});

export type Merch = z.infer<typeof merchSchema>;

export const merchSchemaServer = merchSchema.extend({
	scene: fileServerSchema.optional(),
	decorations: z.array(decorationSchemaServer),
	labels: z
		.array(
			decorationSchemaServer.extend({
				size: z.string(),
				colour: z.enum(['black', 'white']),
			}),
		)
		.optional(),
	teamNames: teamNameServerSchema,
});

export const merchFormServerValidator = withZod(merchSchemaServer);

export type MerchFormServer = z.infer<typeof merchSchemaServer>;
